import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import WithEscNavigation from '@hobs/hocs/WithEscNavigation';
import { createLoadingSelector } from '@hobs/utils/loading';
import { forSubmit, update, get, reset } from '@hobs/actions/transportation';
import _Transportation from '@hobs/containers/Transportation';
import {
  SERVICE_REQUEST_NAVIGATION_ORIGIN,
  DATE_FORMAT
} from '@hobs/utils/constants';
import WithRoles from '@hobs/hocs/WithRoles';
import Panel from '@hobs/components/Panel';
import InputLabel from '@hobs/components/InputLabel';
import { H2 } from '@hobs/components/Headings';
import { format } from '@hobs/utils/formatWithTimeZone';
import { PageLinks } from '../ServiceRequestEdit/PageLinks';

class Transportation extends _Transportation {
  getBackNavigationUrl = navContext => {
    if (navContext === SERVICE_REQUEST_NAVIGATION_ORIGIN.AnnexOverview) {
      return '/annex-overview';
    } else if (navContext === SERVICE_REQUEST_NAVIGATION_ORIGIN.Tickets) {
      return '/tickets';
    }
    return '/requested-services';
  };

  renderTransportationInfo() {
    return null;
  }

  renderExportButton() {
    return null;
  }

  getDiscussionPath() {
    const { match } = this.props;
    return `${match.url}/discussion`;
  }

  getInitialValues() {
    const {
      transportation,
      transportation: { deliveryDetails, pickupDetails }
    } = this.props;

    pickupDetails.transportationTime = this.setTransportationTime(
      pickupDetails.transportationTime
    );
    deliveryDetails.transportationTime = this.setTransportationTime(
      deliveryDetails.transportationTime
    );

    return {
      ...this.convertObjectNullsToString(transportation),
      generalInformation: this.convertObjectNullsToString(
        transportation.generalInformation
      ),
      pickupDetails: {
        ...this.convertObjectNullsToString(pickupDetails),
        transportationTime: pickupDetails.transportationTime
          ? {
              ...pickupDetails.transportationTime,
              time: pickupDetails.transportationTime.hour
                ? format(
                    new Date(
                      `1970-01-01 ${pickupDetails.transportationTime.hour}:${pickupDetails.transportationTime.minute}:00`
                    ),
                    'HH:mm'
                  )
                : ''
            }
          : {
              date: '',
              time: ''
            }
      },
      deliveryDetails: {
        ...this.convertObjectNullsToString(deliveryDetails),
        transportationTime: deliveryDetails.transportationTime
          ? {
              ...this.convertObjectNullsToString(
                deliveryDetails.transportationTime
              ),
              time: format(
                new Date(
                  `1970-01-01 ${deliveryDetails.transportationTime.hour}:${deliveryDetails.transportationTime.minute}:00`
                ),
                'HH:mm'
              )
            }
          : {
              date: '',
              time: ''
            },
        remarks: deliveryDetails.remarks ? deliveryDetails.remarks : ''
      }
    };
  }

  renderGeneralInformation() {
    const { t } = this.props;

    return (
      <Panel>
        <div className="transportation--panel">
          <H2>{t('General information')}</H2>

          <div className="transportation--fields-row">
            <div className="transportation--field">
              <InputLabel>{t('Last update')}</InputLabel>
              <div>
                {format(
                  this.props.transportation.generalInformation.modifiedDate,
                  DATE_FORMAT
                )}
              </div>
            </div>
          </div>
        </div>
      </Panel>
    );
  }

  renderPageLinks(dirty) {
    const { t, match, get } = this.props;

    return (
      <PageLinks
        isDirty={dirty}
        isTransportation={true}
        partyId={match.params.partyId}
        isCustom={false}
        serviceRequestId={match.params.serviceRequestId}
        changeHistoryPath={`/service-request/${match.params.serviceRequestId}/change-history`}
        discussion={{
          status: this.props.transportation.discussionStatusId,
          initials: t('SN'),
          discussionPath: this.getDiscussionPath(),
          onDiscussionClose: () => get(match.params.serviceRequestId),
          isSeen: this.props.transportation.isLastDiscussionSeen
        }}
      />
    );
  }
}

const oDataLoading = createLoadingSelector([
  'Exercises/Current',
  'Transportation/Get',
  'Transportation/ForSubmit'
]);

const mapStateToProps = state => ({
  transportation: state.transportation.item,
  forSubmitData: state.transportation.forSubmit,
  isLoading: oDataLoading(state)
});

const mapDispatchToProps = {
  forSubmit,
  reset,
  update,
  get
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(WithEscNavigation(WithRoles(Transportation)))));
